import { PERSON_TYPE_ENUM } from 'enums/PersonTypeEnum'

export function definePersonType(document: string | number) {
  const documentFormatted = String(document).replace(/\D/, '')

  if (documentFormatted.length > 11) {
    return PERSON_TYPE_ENUM.JURIDICAL
  }

  return PERSON_TYPE_ENUM.NATURAL
}
